import { RECORDING_WAIT_TIMEOUT_MS, type RecordingStatus } from "./recording-contracts";

export function isRecordingProcessingStatus(status: RecordingStatus): boolean {
  return ["capturing", "awaiting_provider", "archiving", "composing"].includes(status);
}

export function isRecordingWaitExpired(
  referenceTime: Date | string | number | null | undefined,
  now = Date.now(),
): boolean {
  if (referenceTime == null) return false;
  const timestamp = referenceTime instanceof Date ? referenceTime.getTime() : new Date(referenceTime).getTime();
  return Number.isFinite(timestamp) && now - timestamp >= RECORDING_WAIT_TIMEOUT_MS;
}
